<template>
  <div class="payment-info">
    <div class="row">
      <div class="col-md-5 d-flex align-items-center justify-content-center">
        <div class="qr-box">
          <img
              v-if="qrUrl"
              :src="qrUrl"
              alt="QR Code thanh toán công nợ"
              class="qr-image"
          />
          <div v-else class="qr-empty text-muted text-center">
            <i class="el-icon-picture-outline" style="font-size: 32px"></i>
            <div class="mt-2">Chưa có thông tin tài khoản để tạo mã QR</div>
          </div>
        </div>
      </div>

      <div class="col-md-7">
        <div class="info-row">
          <span class="info-label">Ngân hàng</span>
          <span class="info-value">{{ bankName || '--' }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Chủ tài khoản</span>
          <span class="info-value">{{ accountName || '--' }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Số tài khoản</span>
          <span class="info-value">{{ accountNumber || '--' }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Số tiền</span>
          <span class="info-value text-danger font-weight-bold">{{ amount | formatVND }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Nội dung chuyển khoản</span>
          <span class="info-value font-weight-bold">{{ description || '--' }}</span>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-4">
      <el-button
          @click="$emit('close')"
          size="small"
          class="text-white rounded"
          style="background-color: #5D04B0"
      >
        Đóng
      </el-button>
    </div>
  </div>
</template>

<script>
/**
 * Mã ngân hàng (BIN) theo chuẩn VietQR cho các ngân hàng đang sử dụng:
 * ACB, MB, Vietinbank, Techcombank
 * Xem thêm: https://api.vietqr.io/v2/banks
 */
const VIET_QR_BANK_BIN = {
  acb: '970416',
  mb: '970422',
  mbbank: '970422',
  vietinbank: '970415',
  viettinbank: '970415',
  techcombank: '970407',
  tcb: '970407',
};

const VIET_QR_TEMPLATE = 'compact2';

export default {
  name: "dialog-payment-info",

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    // Tài khoản nhận thanh toán của từng log được snapshot trong destination
    destination() {
      return this.data?.destination || {};
    },

    bankName() {
      return this.destination.bankName || '';
    },

    accountName() {
      return this.destination.accountName || '';
    },

    accountNumber() {
      return this.destination.accountNumber || '';
    },

    amount() {
      return Number(this.data?.so_tien_tra_gop || 0);
    },

    description() {
      const phone = String(this.data?.sdt_hoc_vien || '').trim();
      return phone ? `CT${phone}` : '';
    },

    bankId() {
      const bankCode = String(this.destination.bankCode || '').trim();
      if (bankCode) return bankCode;

      const key = String(this.bankName).toLowerCase().replace(/[^a-z]/g, '');
      return VIET_QR_BANK_BIN[key] || '';
    },

    qrUrl() {
      if (!this.bankId || !this.accountNumber) return '';

      const params = [
        `amount=${encodeURIComponent(this.amount)}`,
        `addInfo=${encodeURIComponent(this.description)}`,
        `accountName=${encodeURIComponent(this.accountName)}`,
      ].join('&');

      return `https://img.vietqr.io/image/${this.bankId}-${encodeURIComponent(this.accountNumber)}-${VIET_QR_TEMPLATE}.png?${params}`;
    },
  },
};
</script>

<style scoped>
.qr-box {
  width: 100%;
  padding: 8px;
  border: 1px solid #EBEEF5;
  border-radius: 8px;
  background-color: #FAFAFA;
}

.qr-image {
  width: 100%;
  height: auto;
  display: block;
}

.qr-empty {
  padding: 40px 12px;
}

.info-row {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  border-bottom: 1px dashed #EBEEF5;
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  font-size: 13px;
  color: #909399;
}

.info-value {
  font-size: 15px;
  color: #282828;
  word-break: break-word;
}
</style>
